import { newsArticles } from "@/mocks/newsArticles";
import { newsCategories } from "@/mocks/newsCategories";
import type { NewsArticle, NewsCategory } from "@/types/news";

export function getArticleById(id: string): NewsArticle | undefined {
  return newsArticles.find((item) => item.id === id);
}

export function getArticlesByCategory(slug: string): NewsArticle[] {
  if (!slug || slug === "all") {
    return newsArticles;
  }
  return newsArticles.filter((item) => item.category === slug);
}

export function getCategoryBySlug(slug: string): NewsCategory | undefined {
  return newsCategories.find((item) => item.slug === slug);
}

export function getBreakingArticles(limit = 5): NewsArticle[] {
  return newsArticles.filter((item) => item.isBreaking).slice(0, limit);
}

export function getHotArticles(limit = 6): NewsArticle[] {
  return [...newsArticles].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getRelatedArticles(article: NewsArticle, limit = 3): NewsArticle[] {
  const sameCategory = newsArticles.filter(
    (item) => item.id !== article.id && item.category === article.category,
  );
  const others = newsArticles.filter(
    (item) => item.id !== article.id && item.category !== article.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}万`;
  }
  return `${heat}`;
}

export function searchArticles(keyword: string): NewsArticle[] {
  const key = keyword.trim().toLowerCase();
  if (!key) {
    return newsArticles;
  }
  return newsArticles.filter((item) => {
    const pool = `${item.title}${item.summary}${item.categoryName}${item.tags.join("")}`.toLowerCase();
    return pool.includes(key);
  });
}